module.exports = __webpack_public_path__ + "img/ico-shipping.b9e877f3.svg";